import { Form } from "antd";
import { useEffect } from "react";
import { requetsAssetsSimulation } from "../../../../redux/slices/simulation/simulationAction";

export const useFieldsAssetsSimulation = (dispatch, formState) => {
    const [form] = Form.useForm();

    const onFinish = (values, updateProjects) => {
        dispatch(requetsAssetsSimulation(values, updateProjects));
    };

    useEffect(() => {
        form.setFieldsValue({
            ...formState,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState]);

    return { form, onFinish };
};
